import { defineAsyncComponent } from 'vue'

const PurposeTag = defineAsyncComponent(() => import('./purpose-tag.vue'))
const PurposeTagFormModal = defineAsyncComponent(() => import('./purpose-tag-form-modal.vue'))
const PurposeTagsSelect = defineAsyncComponent(() => import('./purpose-tags-select.vue'))
const PurposeTagsService = defineAsyncComponent(() => import('./purpose-tags-service.ts'))

export { PurposeTag, PurposeTagFormModal, PurposeTagsSelect, PurposeTagsService }

